import { Extent } from 'openlayers'
import { LayerActiveView } from 'src/components/layerpicker/LayerPicker'
import { DataAction, EmptyAction } from 'src/CustomTypes'
import { LayerCapabilities, LayerGroup, LayerParams, LayerType } from 'src/dataSources/layers/LayerRegistry'
import { LayerViewType } from 'src/Enums'

export const SET_MAP_CENTER = 'MAP_ACTIONS_SET_MAP_CENTER'
export const SET_MAP_CURRENT_ZOOM = 'MAP_ACTIONS_SET_MAP_CURRENT_ZOOM'
export const SET_MAP_EXTENT = 'MAP_ACTIONS_SET_MAP_EXTENT'
export const SET_COLORS_IN_FOCUS = 'MAP_ACTIONS_SET_COLORS_IN_FOCUS'
export const ADD_LAYER = 'MAP_ACTIONS_ADD_LAYER'
export const ADD_LAYER_GROUP = 'MAP_ACTIONS_ADD_LAYER_GROUP'
export const REMOVE_LAYER = 'MAP_ACTIONS_REMOVE_LAYER'
export const REMOVE_LAYER_GROUP = 'MAP_ACTIONS_REMOVE_LAYER_GROUP'
export const CLEAR_LAYERS = 'MAP_ACTIONS_CLEAR_LAYERS'
export const SET_LAYER_PARAMS = 'MAP_ACTIONS_SET_LAYER_PARAMS'
export const SET_LAYER_ACTIVE_VIEW = 'MAP_ACTIONS_SET_ACTIVE_VIEW'
export const SET_LAYER_CAPABILITIES = 'MAP_ACTIONS_SET_LAYER_CAPABILITIES'

export interface ColorInFocus {
  layerType: LayerType
  color: string
}

interface MapActions {
  setMapCenter: (center: ol.Coordinate) => DataAction<ol.Coordinate>
  setMapCurrentZoom: (currentZoom: number) => DataAction<number>
  setMapExtent: (extent: Extent) => DataAction<Extent>
  setColorsInFocus: (colorsInFocus: ColorInFocus[]) => DataAction<ColorInFocus[]>
  addLayer: (layer: LayerType) => DataAction<LayerType>
  addLayerGroup: (layerGroup: LayerGroup) => DataAction<LayerGroup>
  clearLayers: () => EmptyAction
  removeLayer: (layer: LayerType) => DataAction<LayerType>
  removeLayerGroup: (layerGroup: LayerGroup) => DataAction<LayerGroup>
  setLayerActiveView: (layer: LayerType, view: LayerViewType) => DataAction<LayerActiveView>
  setLayerParams: (config: LayerParams) => DataAction<LayerParams>
  setLayerCapabilities: (capabilities: LayerCapabilities) => DataAction<LayerCapabilities>
}

export const mapActions: MapActions = {
  setMapCenter: (center: ol.Coordinate): DataAction<ol.Coordinate> => {
    return {
      type: SET_MAP_CENTER,
      data: center
    }
  },
  setMapCurrentZoom: (currentZoom: number): DataAction<number> => {
    return {
      type: SET_MAP_CURRENT_ZOOM,
      data: currentZoom
    }
  },
  setMapExtent: (mapExtent: Extent): DataAction<Extent> => {
    return {
      type: SET_MAP_EXTENT,
      data: mapExtent
    }
  },
  setColorsInFocus: (colorsInFocus: ColorInFocus[]): DataAction<ColorInFocus[]> => {
    return {
      type: SET_COLORS_IN_FOCUS,
      data: colorsInFocus
    }
  },
  addLayer: (layer: LayerType): DataAction<LayerType> => {
    return {
      type: ADD_LAYER,
      data: layer
    }
  },
  addLayerGroup: (layerGroup: LayerGroup): DataAction<LayerGroup> => {
    return {
      type: ADD_LAYER_GROUP,
      data: layerGroup
    }
  },
  clearLayers: (): EmptyAction => {
    return {
      type: CLEAR_LAYERS
    }
  },
  removeLayer: (layer: LayerType): DataAction<LayerType> => {
    return {
      type: REMOVE_LAYER,
      data: layer
    }
  },
  removeLayerGroup: (layerGroup: LayerGroup): DataAction<LayerGroup> => {
    return {
      type: REMOVE_LAYER_GROUP,
      data: layerGroup
    }
  },
  setLayerActiveView: (layer: LayerType, view: LayerViewType): DataAction<LayerActiveView> => {
    return {
      type: SET_LAYER_ACTIVE_VIEW,
      data: {
        type: layer,
        view: view
      }
    }
  },
  setLayerParams: (params: LayerParams): DataAction<LayerParams> => {
    return {
      type: SET_LAYER_PARAMS,
      data: params
    }
  },
  setLayerCapabilities: (capabilities: LayerCapabilities): DataAction<LayerCapabilities> => {
    return {
      type: SET_LAYER_CAPABILITIES,
      data: capabilities
    }
  }
}
